<!-- 学校-延时课表 -->
<template>
  <div>
    <div
      class="index"
      v-loading="loading"
      v-show="!teacher_detail.show && !student_detail.show"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="学校课表" name="schoolTable"></el-tab-pane>
        <el-tab-pane label="班级课表" name="classTable"></el-tab-pane>
      </el-tabs>
      <div>
        <el-form
          :inline="true"
          :model="queryParams"
          label-width="45px"
          style="padding-top: 20px"
        >
          <el-form-item label="学年学期" label-width="70px">
            <el-select
              v-model="queryParams.semester"
              placeholder="请选择"
              class="label"
              style="width: 220px"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="校区">
            <el-select
              v-model="queryParams.campusId"
              placeholder="请选择"
              class="label"
              @change="getDataList"
            >
              <el-option
                v-for="item in campusList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级">
            <el-select
              v-model="queryParams.gradeId"
              @change="getDataList"
              clearable
              placeholder="请选择"
              class="label"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <br />
          <el-form-item label="课程" label-width="70px">
            <el-input
              v-model="queryParams.courseName"
              clearable
              placeholder="请输入"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item v-if="activeName == 'classTable'" label="班级">
            <el-input
              v-model="queryParams.className"
              clearable
              placeholder="请输入"
              style="width: 220px"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="教师">
            <el-input
              v-model="queryParams.teacherName"
              clearable
              placeholder="请输入"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="周次">
            <el-select
              v-model="queryParams.week"
              placeholder="请选择"
              class="label"
              @change="getDataList"
              style="width: 270px"
            >
              <el-option
                v-for="item in weekList"
                :key="item.id + 'week'"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
            <!-- <Export-excel id="classTable" :name="`${Userlist.last_top_org_name}第${queryParams.week}周课表`"></Export-excel> -->
          </el-form-item>
          <el-form-item label="" style="float: right">
            <el-button type="primary" size="small" @click="downloadBmExcel()"
              >导出课表</el-button
            >
          </el-form-item>
        </el-form>

        <div class="header">
          <div class="header-left">
            <p>
              {{ Userlist.last_top_org_name }}第{{ queryParams.week }}周课表
            </p>
            <div class="btn-box">
              <div
                class="btn-item"
                @click="nextWeekFun(-1)"
                :class="{ no_click: queryParams.week == 1 }"
              >
                <img
                  src="./imgs/left_icon.svg"
                  alt=""
                  style="margin-right: 10px"
                />
                <el-button type="text">上周</el-button>
              </div>
              <el-button
                type="text"
                style="margin-left: 20px"
                @click="nextWeekFun(0)"
                :class="{ no_click: !isWeek || queryParams.week == 1 }"
                >本周</el-button
              >
              <div
                class="btn-item"
                @click="nextWeekFun(1)"
                :class="{ no_click: queryParams.week == lastWeek }"
              >
                <el-button type="text" style="margin-left: 20px"
                  >下周</el-button
                >
                <img
                  src="./imgs/right_icon.svg"
                  alt=""
                  style="margin-left: 10px"
                />
              </div>
            </div>
            <div class="sort">
              <!-- <span>排序:</span>
                        <span>课程数</span> -->
              <!-- <img src="./imgs/sort.svg" alt=""> -->
            </div>
          </div>

          <!-- <el-button style="height:32px" size="small">修改课表</el-button> -->
        </div>

        <!-- 课程表 -->
        <template v-if="tableData && Object.keys(tableData).length">
          <div class="class-table" id="classTable">
            <div class="table-wrapper">
              <div class="table-container" id="exportOutTable">
                <table>
                  <thead>
                    <tr style="background: #f7f7f7">
                      <th class="th-one" colspan="2">
                        <span class="bottom"> 班级/课节 </span>
                        <div class="line"></div>
                        <span class="top">日期</span>
                      </th>
                      <th v-for="(week, index) in weeks" :key="index">
                        <p>{{ week.value || "" }}</p>
                        <p>{{ week.date || "" }}</p>
                        <!-- {{ week.value + " " }}{{ week.date || "" }} -->
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(it, i) in tableData" :key="i">
                      <td
                        :rowspan="it.courseNamerow"
                        v-if="!it.courseNameshow"
                        style="background: #f7f7f7"
                      >
                        <p style="font-weight: bold; color: #000">
                          {{ it.courseName }}
                        </p>
                      </td>
                      <td>
                        <p>{{ it.courseData }}</p>
                      </td>
                      <td v-for="(day, index) in it.courseList" :key="index">
                        <div class="td-box" v-if="day">
                          <p style="font-weight: bold; color: #000">
                            {{ day.courseName }}
                          </p>
                          <p>
                            <span
                              class="statistical_class"
                              @click="toStatistical(day, 'teacher')"
                              >{{ day.teacherName }}
                              <span v-if="day.extOrgName"
                                >( {{ day.extOrgName }} )
                              </span>
                            </span>
                          </p>
                          <p v-if="day.locationName && day.locationName != ''">
                            上课地点：{{ day.locationName }}
                          </p>
                          <p v-if="day.currentClassNum && day.classNum">
                            当前课时/总课时：{{ day.currentClassNum }}/{{
                              day.classNum
                            }}
                          </p>
                          <p v-if="day.selectedCount && day.totalLimit">
                            报名数/招生数：<span
                              class="statistical_class"
                              @click="toStatistical(day, 'student')"
                              >{{ day.selectedCount }}</span
                            >/{{
                              day.totalLimit != 99999 ? day.totalLimit : "不限"
                            }}
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <img class="no_data" src="@/assets/img/no_data.svg" alt="" />
        </template>
      </div>
    </div>
    <TeacherDetail
      :info="teacher_detail.info"
      v-show="teacher_detail.show"
      @to-index="toIndex"
      :semester="detail_semester"
      :semesterList="semesterList"
    ></TeacherDetail>
    <StudentDetail
      :info="student_detail.info"
      v-show="student_detail.show"
      @to-index="toIndex"
      :semester="detail_semester"
      :semesterList="semesterList"
    ></StudentDetail>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index.js";
import util from "@/utils/util.js";
import _ from "lodash";
import dayjs from "dayjs";
export default {
  components: {
    TeacherDetail: () => import("./teacher_detail.vue"),
    StudentDetail: () => import("./student_detail.vue"),
    ExportExcel: () => import("@/views/components/exportExcel.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        campusId: "",
        gradeId: "",
        week: 1,
        teacherName: "",
        courseName: "",
        className: "",
      },
      activeName: "schoolTable",
      weekList: [],
      isWeek: false,
      lastWeek: 0,
      weekData: [],
      campusList: [],
      gradeList: [],
      courseList: [],
      teacherList_1: [
        { id: 1, label: "本校" },
        { id: 2, label: "机构" },
      ],
      teacherList_2: [],
      userList: [],
      semesterList: [],
      teacherList: [],
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")) || [],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      setting: {
        info: {},
        show: false,
      },
      weeks: [],
      tableShow: false,
      nextWeek: 0,
      todayWeek: {},
      Userlist: JSON.parse(sessionStorage.getItem("userInfo")) || {},
      loading: false,
      detail_semester: "",
      teacher_detail: {
        info: {},
        show: false,
      },
      student_detail: {
        info: {},
        show: false,
      },
    };
  },
  watch: {
    "queryParams.campusId": function (n, o) {
      this.gradeList = [];
      this.gradeList =
        this.campusList.filter((v) => v.id === n)[0]?.children || [];
    },
    "queryParams.semester": function (n, o) {
      this.getWeekData(n);
      // let semesterRes = this.semesterList.filter((e) => e.value === n);
      // if (semesterRes[0].startDate) {
      //   this.weekList = util.showCourse(semesterRes[0].startDate);
      // } else {
      //   this.weekList = [
      //     { id: 1, label: "第1周" },
      //     { id: 2, label: "第2周" },
      //     { id: 3, label: "第3周" },
      //     { id: 4, label: "第4周" },
      //     { id: 5, label: "第5周" },
      //     { id: 6, label: "第6周" },
      //     { id: 7, label: "第7周" },
      //     { id: 8, label: "第8周" },
      //     { id: 9, label: "第9周" },
      //     { id: 10, label: "第10周" },
      //     { id: 11, label: "第11周" },
      //     { id: 12, label: "第12周" },
      //     { id: 13, label: "第13周" },
      //     { id: 14, label: "第14周" },
      //     { id: 15, label: "第15周" },
      //     { id: 16, label: "第16周" },
      //     { id: 17, label: "第17周" },
      //     { id: 18, label: "第18周" },
      //     { id: 19, label: "第19周" },
      //     { id: 20, label: "第20周" },
      //   ];
      // }
      // if (semesterRes[0].isCurrent) {
      //   this.queryParams.week = this.todayWeek.week || 1;
      // } else {
      //   this.queryParams.week = 1;
      // }
      // console.log('延时课表---',this.weekList);
      this.getDataList();
    },
  },
  created() {
    if (this.semesterArr && this.semesterArr.length > 0) {
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
        isCurrent: v.isCurrent,
        startDate: v.startDate,
        endDate: v.endDate,
      }));
      let semesterRes = this.semesterList.filter((e) => e.isCurrent);
      this.queryParams.semester = semesterRes[0]?.value;
      // let weekObj = util.TodayInfo(semesterRes[0]?.startDate);
      // if (weekObj) {
      //   if (weekObj.week > 20){
      //     weekObj.week = 20;
      //     this.week_disabled = true;
      //   }
      //   this.queryParams.week = weekObj.week;
      //   this.todayWeek = weekObj;
      // }
    }

    this.campusList = this.school_info.slice();
    if (this.campusList.length) {
      this.queryParams.campusId = this.campusList[0].id;
    }
  },
  methods: {
    digital2Chinese(num, identifier) {
      const character = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
      ];
      return identifier === "week" && (num === 0 || num === 7)
        ? "日"
        : character[num];
    },
    nextWeekFun: _.throttle(
      async function (type) {
        if (
          (this.queryParams.week == 1 && type == -1) ||
          (this.queryParams.week == this.lastWeek && type == 1)
        )
          return false;
        if (type === 0) {
          // 回到本周
          if (this.weekData.length > 0) {
            let nowDate = dayjs(new Date().getTime()).format("YYYY-MM-DD");
            this.weekData.forEach((it) => {
              if (it.semesterDateList && it.semesterDateList.length > 0) {
                it.semesterDateList.forEach((j) => {
                  if (j && j.date && j.date.indexOf(nowDate) != -1) {
                    this.queryParams.week = it.weekNum || 1;
                  }
                });
              }
            });
          } else {
            this.queryParams.week = 1;
          }
        } else {
          this.queryParams.week += type;
        }
        this.getDataList();
      },
      1500,
      { leading: true, trailing: false }
    ),
    // async getDataList() {
    //   try {
    //     this.loading = true;
    //     let params = {
    //       orgId: sessionStorage.getItem("orgId"),
    //       platformCode: sessionStorage.getItem("platformCode"),
    //       schoolYearSemester: this.queryParams.semester,//	学年学期
    //       campusId: this.queryParams.campusId,//	校区Id
    //       gradeId: this.queryParams.gradeId,//	年级Id
    //       weekNum: this.queryParams.week,//	第几周
    //       nextWeek: "",//0 本周 1 上一周 -1 下一周
    //       courseSource: "",//课程来源 1 本校 2 外部机构
    //       teacherName: this.queryParams.teacherName,
    //     };
    //     let res = await api.schoolHandleTimetable(params);
    //     if (res.code === "0") {
    //       this.weeks = res.data.weeks;
    //       this.tableData = res.data.timetableMap;
    //       this.filterWeeks(this.weeks)
    //       this.detail_semester = this.queryParams.semester;
    //     } else {
    //       this.tableData = [];
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    async getDataList() {
      this.tableData = [];
      try {
        this.loading = true;
        let _this = this;
        let params = {
          orgId: sessionStorage.getItem("orgId"),
          platformCode: sessionStorage.getItem("platformCode"),
          schoolYearSemester: _this.queryParams.semester, //	学年学期
          campusId: this.queryParams.campusId, //	校区Id
          weekNum: _this.queryParams.week, //	第几周
          courseType: _this.activeName == "schoolTable" ? "1" : "2", //1-校内社团课 2-作业看管课构
          teacherName: _this.queryParams.teacherName,
          courseName: _this.queryParams.courseName,
          gradeId: _this.queryParams.gradeId,
        };
        if (_this.activeName == "classTable") {
          params.className = _this.queryParams.className;
        }
        let res =
          _this.activeName == "schoolTable"
            ? await api.handleSchoolTimetable(params)
            : await api.handleClassTimetable(params);
        if (res.code === "0") {
          this.weeks = res.data.weeks;
          for (var k in res.data.timetableMap) {
            if (Object.keys(res.data.timetableMap[k]).length != 0) {
              for (var j in res.data.timetableMap[k]) {
                let classList = [null, null, null, null, null];
                res.data.timetableMap[k][j].forEach((it) => {
                  classList[it.dayOfWeek - 1] = it;
                });
                let courseObj = {
                  courseName: k,
                  courseData: j,
                  courseList: classList,
                };
                _this.tableData.push(courseObj);
              }
            }
          }
          _this.combineCell(_this.tableData);
          _this.filterWeeks(_this.weeks);
          _this.detail_semester = _this.queryParams.semester;
        } else {
          _this.tableData = [];
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    combineCell(list) {
      for (let field in list[0]) {
        var k = 0;
        while (k < list.length) {
          list[k][field + "row"] = 1;
          list[k][field + "show"] = false;
          for (var i = k + 1; i <= list.length - 1; i++) {
            if (list[k][field] == list[i][field] && list[k][field] != "") {
              list[k][field + "row"]++;
              list[k][field + "show"] = false;
              list[i][field + "row"] = 1;
              list[i][field + "show"] = true;
            } else {
              break;
            }
          }
          k = i;
        }
      }
      return list;
    },
    // 获取学期周次信息
    async getWeekData(semester) {
      this.weekList = [];
      let res = await api.getWeekInfo({
        orgId: sessionStorage.getItem("orgId") || "",
        schoolYearSemester: semester || this.queryParams.semester,
      });
      if (res.code === "0") {
        if (res.data.length > 0) {
          this.weekData = res.data;
          //获取最后一周为第几周
          this.lastWeek = res.data[res.data.length - 1].weekNum || 0;
          res.data.forEach((it) => {
            this.weekList.push({
              id: it.weekNum,
              label: `第${it.weekNum}周 (${it.startDate.date.slice(
                0,
                10
              )}至${it.endDate.date.slice(0, 10)})`,
            });
          });
          //判断今天是不是本周次内
          this.isWeek = util.isWeekInData(res.data);
        } else {
          this.queryParams.week = null;
        }
      }
       // 获取本周周次
       this.nextWeekFun(0)
    },
    //解决接口返回没有日期时进行补充
    filterWeeks(weeks) {
      var oneDayTime = 24 * 60 * 60 * 1000;
      let haveValue = weeks.find((it) => {
        return it.date;
      });
      weeks.forEach((it) => {
        if (!it.date) {
          if (it.key > haveValue.key) {
            it.date = util.timestampToTime(
              new Date(haveValue.date).getTime() +
                oneDayTime * (it.key - haveValue.key)
            );
          } else {
            it.date = util.timestampToTime(
              new Date(haveValue.date).getTime() -
                oneDayTime * (haveValue.key - it.key)
            );
          }
        }
      });
    },
    downloadBmExcel() {
      let vm = this;
      let excelHtml = document.getElementById("exportOutTable")?.outerHTML;
      let html =
        "<html><head><meta charset='utf-8' /></head><body>" +
        excelHtml +
        "</body></html>";
      let blob = new Blob([html], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      let excelTitle = `${vm.Userlist.last_top_org_name}第${vm.queryParams.week}周课表.docx`;
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, "表格名称.docx");
      } else {
        let a = document.createElement("a");
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = excelTitle;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
      // let titles = [
      //   vm.weeks[0].value + vm.weeks[0].date,
      //   vm.weeks[1].value + vm.weeks[1].date,
      //   vm.weeks[2].value + vm.weeks[2].date,
      //   vm.weeks[3].value + vm.weeks[3].date,
      //   vm.weeks[4].value + vm.weeks[4].date,
      // ];
      // let keys = ["courseName", "courseData", null];
      // let groups = [];
      // vm.tableData.map((v)=>{
      //   if(!v.type){
      //     groups.push(v);
      //   }
      // })
      // groups = [
      //   {
      //     came: "今日说法",
      //     editing: false,
      //     id: "c9e9bc6b8a200001c9eb127049c02a00",
      //     index: 0,
      //     ismulu: true,
      //     name: "讯问笔录（（被告）第1次",
      //     range: "1-3",
      //     respon: "",
      //     select: false,
      //   },
      //   {
      //     came: "新闻30分",
      //     editing: false,
      //     id: "c9e9bc6b8a200001c9eb127049c02a01",
      //     index: 1,
      //     ismulu: true,
      //     name: "讯问笔录（（被告）第2次",
      //     range: "1-3-3",
      //     respon: "",
      //     select: false,
      //   },
      //   {
      //     editing: false,
      //     id: "c9e9bc6b8a200001c9eb127049c02a02",
      //     index: 2,
      //     ismulu: true,
      //     name: "讯问笔录（（被告）第3次",
      //     range: "1-3-4",
      //     respon: "",
      //     select: false,
      //   },
      // ];
      // util.downloadExcel(
      //   vm.tableData,
      //   `${vm.Userlist.last_top_org_name}第${vm.queryParams.week}周课表`,
      //   titles,
      // );
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
      if (tab.name == "classTable") {
        this.gradeList.forEach((it) => {
          if (it.label == "小学二年级2021级") {
            this.queryParams.gradeId = it.id || "";
          }
        });
      } else {
        this.queryParams.gradeId = "";
      }
      this.getDataList();
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toStatistical(item, type) {
      console.log("教师/学生考勤", item);
      if (type === "teacher") {
        this.teacher_detail.info = item;
        this.teacher_detail.show = true;
      } else {
        this.student_detail.info = item;
        this.student_detail.show = true;
      }
    },
    toIndex() {
      this.teacher_detail.show = false;
      this.student_detail.show = false;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    width: 100%;
    height: 50px;
    border-radius: 3px;
    background: #eff6ff;
    border: 1px solid #ddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    font-size: 14px;
    .header-left {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        color: #000;
      }
    }
    .btn-box {
      margin-left: 30px;
      display: flex;
      align-items: center;
      .btn-item {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .no_click {
        opacity: 0.3;
        cursor: not-allowed !important;
        button {
          cursor: not-allowed !important;
        }
      }
    }

    .sort {
      margin-left: 30px;
      span {
        margin-right: 20px;
        color: #8b8b8b;
      }
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }
  ::v-deep .el-tabs__nav {
    height: 42px;
    margin-top: 5px;
  }
  .class-table {
    table,
    table tr th,
    table tr td {
      border: 1px solid #ddd;
      padding: 5px;
    }
    table {
      min-height: 25px;
      line-height: 25px;
      text-align: center;
      border-collapse: collapse;
    }
    .table-wrapper {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
    .table-container {
      table {
        table-layout: fixed;
        width: 100%;

        thead {
          background-color: #fff;
          th {
            font-weight: bold;
            font-size: 14px;
            color: #000;
          }
          .th-one {
            width: 180px;
            height: 50px;
            position: relative;
            .line {
              position: absolute;
              width: 1px;
              height: 197px; /*这里需要自己调整，根据td的宽度和高度*/
              top: 0;
              left: 0;
              background-color: #dddddd;
              transform: rotate(-73.5deg); /*这里需要自己调整，根据线的位置*/
              transform-origin: top;
            }
            .top {
              position: absolute;
              // color: #9b9b9b;
              color: #000;
              right: 20px;
              top: 10px;
            }
            .bottom {
              position: absolute;
              // color: #9b9b9b;
              color: #000;
              left: 20px;
              bottom: 10px;
            }
          }
        }
        tbody {
          td {
            // border: 1px solid #ddd;
            text-align: center;
            color: #555;
          }
        }

        // tr td:first-child {
        //   font-weight: bold;
        //   font-size: 14px;
        //   color: #000;
        //   .period {
        //     font-size: 8px;
        //   }
        // }
      }
      .statistical_class {
        color: #4991e1;
        cursor: pointer;
      }
    }
    .td-box {
      .ellipsis {
        // 省略号
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }

  .no_data {
    margin: 100px 350px;
  }
}
</style>
